import React from 'react';
import { useTranslation } from 'react-i18next';
import './ticket.css'
import TicketCard from './ticket-card';
import LabelDetails from './label-details';
import i18n from 'i18next';
import { Status } from '../ui';
import QRCode from 'react-qr-code';

export default function TicketCardContainer({ attendee }) {
	const { t } = useTranslation();

	const { first_name, last_name, id_weez_ticket, barcode, currency, paid_price, status, rate_name } = attendee;

	const price = new Intl.NumberFormat(i18n.language.replace("_", "-"), { style: 'currency', currency: currency }).format(paid_price);

    const activeStatus = React.useMemo(() => {
        if (status === 'active' || status === "free" || status === "paid") {
            return "valid"
        }
        return status
    },[status]);

    const statusColor = React.useMemo(() => {
        if (activeStatus === "valid") {
            return 'green';
        } else if (activeStatus === 'reserved') {
            return 'orange'
        } else {
            return 'red';
        }
    }, [activeStatus]);

	return (
		<TicketCard id="ticket">
			<TicketCard.Header>
				<div style={{ display: 'flex', alignItems: 'center', fontSize: '18px', marginLeft: '-5px' }}>
					<span className="wz-neo-username">
						<span className="wz-neo-lastname"><strong>{last_name}</strong></span>
						<span className="wz-neo-firstname"><strong>{first_name}</strong></span>
					</span>
				</div>
				<LabelDetails.Container>
					<LabelDetails title={t('widget.step-confirm.rate')} className="margin-top-2">
						<div><strong>{rate_name}</strong></div>
					</LabelDetails>
				</LabelDetails.Container>
			</TicketCard.Header>
			<TicketCard.Content ticket>
				<LabelDetails.Container>
					<LabelDetails title={t('widget.step-confirm.price')}>
						<div className={'ticket-card__price'}>
							<span>{price}</span>
						</div>
					</LabelDetails>
					<LabelDetails title={t('widget.step-confirm.status')}>
						<Status color={statusColor} text={t(`widget.resale.header.status.${activeStatus}`)}/>
					</LabelDetails>
				</LabelDetails.Container>
			</TicketCard.Content>
			{
				barcode ?
					<TicketCard.Footer>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<div className={'ticket-card-footer__qr-code'}>
							<QRCode value={barcode} size={45} />
						</div>
						<LabelDetails title={t('widget.step-confirm.barcode')}>
							<div className={'ticket-card-footer__barcode-container'}>
								<div><strong>{barcode}</strong></div>
								<div className={'ticket-card-footer__id-ticket'}>N°{id_weez_ticket}</div>
							</div>
						</LabelDetails>
					</div>
					</TicketCard.Footer>
				: null

			}
			
		</TicketCard>
	)
}
